import { getDate } from "date-fns";
import { AutogenLayoutlayout_diuser } from "./autogen/AutogenLayoutlayout_diuser";
import { DropdownItem, Textbox,  DataDisplayEvent,  DataSourceExecutionEvent,  ClickEvent, Layout,  DropdownSelectionEvent,  ChangeEvent } from "@mcleod/components";
import { Api, DateUtil } from "@mcleod/core";
import { layout_dimuxref } from "./layout_dimuxref";
import { SlideoutDecorator } from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";

export class layout_diuser extends AutogenLayoutlayout_diuser {

    private timer: any;

    override onLoad() {
        //console.log(this);
        const items: DropdownItem[] = [];
        //items.push({ caption: "Desktop", value: "D" });
        //items.push({ caption: "Mobile", value: "M" });
        //items.push({ caption: "API", value: "A" });
        items.push(new DropdownItem("D", "Desktop"));
        items.push(new DropdownItem("M", "Mobile"));
        items.push(new DropdownItem("A", "API"));
        this.textboxDigroupType.items = items;
        this.textboxDigroupType.enabled = true;

        const items2: DropdownItem[] = [];
        //items2.push({ caption: "Active", value: "A" });
        //items2.push({ caption: "Inactive", value: "I" });
        items2.push(new DropdownItem("A", "Active"));
        items2.push(new DropdownItem("I", "Inactive"));
        this.textboxDiuserStatus.items = items2;

        clearInterval(this.timer);
        this.timer = setInterval(() => this.GetUserID_CDate(), 250);
    }

    async GetUserID_CDate()
    {
        //if( this.scnt < 2 )
        //    return; //insure data sources loaded
        clearInterval(this.timer);
        this.timer = null;
        let uid=0, puid=0;
        const today = new Date();
        const cdate = DateUtil.formatDateTime( today, "MM/dd/yyyy" );
        if( this.sourceDiuser.mode == "add" )
        {   //Adding a new record
            await this.sourceDiuser2.search( { diuser_uid: ">0" } );
            for( let i=0; i < this.sourceDiuser2.rowCount; i++ )
            {
                this.sourceDiuser2.rowIndex = i;
                uid = this.sourceDiuser2.activeRow.data.diuser_uid;
                if( uid > puid )
                    puid = uid;
            }
            if( puid > 0 )
            {
                puid += 1;
                this.textboxDiuserUid.text = puid.toString();
            }
            this.textboxDiuserLadate.text = cdate;
            this.textboxDiuserCdate.text = cdate;
        }
        else if( this.sourceDiuser.mode != "search" )
        {   //in update mode
            if( this.textboxDiuserLadate.text == null || this.textboxDiuserLadate.text.length <= 0 )
                this.textboxDiuserLadate.text = cdate;
            if( this.textboxDiuserCdate.text == null || this.textboxDiuserCdate.text.length <= 0 )
                this.textboxDiuserCdate.text = cdate;
            this.textboxDigroupType.enabled = false;
        }
    }

/** This is an event handler for the onDataDisplay event of textboxDigroupType. */
  textboxDigroupTypeOnDataDisplay(event: DataDisplayEvent) {
    if( this.sourceDiuser.mode == "update" && this.textboxDigroupType.text.length <= 0 )
      this.textboxDigroupType.selectedItem = this.textboxDigroupType.items[0];    //default to Desktop Type
    if( this.textboxDigroupType.text == "Mobile" )
    {
        this.mobileXrefButton.visible = true;
        this.sendMobileLinkButton.visible = true;
    }
    else
    {
        this.mobileXrefButton.visible = false;
        this.sendMobileLinkButton.visible = false;
    }
  }

  /** This is an event handler for the afterDropdownSelection event of textboxDigroupType. */
  textboxDigroupTypeAfterDropdownSelection(event: DropdownSelectionEvent) {
    if( this.textboxDigroupType.selectedItem )
    {
        this.textboxDiuserGid.text = "";
        this.sourceDigroup.search( { digroup_type: this.textboxDigroupType.selectedItem.value } );
        if( this.textboxDigroupType.selectedItem.value == "M" )
        {
            this.GetMobileLogin();
            this.textboxDiuserLogin.enabled = false;
        }
        else
        {
            this.textboxDiuserLogin.text = "";
            this.textboxDiuserLogin.enabled = true;
        }
    }
  }

  async GetMobileLogin()
  {
    let uid: number=0, puid: number=0;
    await this.sourceDiuser2.search( { diuser_login: ">0" } );
    for( let i=0; i < this.sourceDiuser2.rowCount; i++ )
    {
        this.sourceDiuser2.rowIndex = i;
        uid = Number(this.sourceDiuser2.activeRow.data.diuser_login);
        if( uid > puid )
            puid = uid;
    }
    if( puid > 0 )
    {
        puid += 1;
        this.textboxDiuserLogin.text = puid.toString();
    }
  }

/** This is an event handler for the onChange event of textboxDiuserFullname. */
  textboxDiuserFullnameOnChange(event: ChangeEvent) {
    let pwd: string = this.textboxDiuserFullname.text;
    const idx = pwd.indexOf(" ");
    let fname="";
    let lname="";
    if( idx > 0 )
    {
        fname = pwd.substring(0,idx);
        lname = pwd.substring(idx+1);
        pwd = fname + "." + lname;
        this.textboxDiuserPasswd.text = pwd;
    }
  }

/** This is an event handler for the afterExecution event of sourceDigroup. */
  sourceDigroupAfterExecution(event: DataSourceExecutionEvent) {
    //if( this.textboxDiuserGid.items )
    //    return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let grpid = null;
    for (const row of rows) {
        if( grpid != row._data.digroup_gid )
        {
            grpid = row._data.digroup_gid;
            let desc = row._data.digroup_desc;
            desc = desc.replace("&","");
            //items.push({ caption: grpid + " - " + desc, value: grpid.toString() });
            items.push(new DropdownItem(grpid.toString(), grpid + " - " + desc));
        }
    }
    this.textboxDiuserGid.items = items;
  }

/** This is an event handler for the onDataDisplay event of textboxDiuserGid. */
  textboxDiuserGidOnDataDisplay(event: DataDisplayEvent) {
    if( this.textboxDiuserGid.selectedItem == null )
        return;
    const grpid = this.textboxDiuserGid.selectedItem.value;
    const gdesc = this.textboxDiuserGid.selectedItem.displayValue;
    const rows: any[] = this.sourceDigroup.data;
    const items: DropdownItem[] = [];
    let desc=null;
    let gtype=null;
    let gtype2=null;
    for( const row of rows )
    {
        if( grpid == row._data.digroup_gid )
        {
            gtype = row._data.digroup_type;
            if( gtype == null )
                gtype = "D";
            break;
        }
    }
    for( const row of rows )
    {
        desc = row._data.digroup_desc;
        if( desc )
            desc = desc.replace("&","");
        gtype2 = row._data.digroup_type;
        if( gtype2 == null )
            gtype2 = "D";
        if( gtype == gtype2 )
            //items.push({ caption: row._data.digroup_gid + " - "+ desc, value: row._data.digroup_gid.toString() });
            items.push(new DropdownItem(row._data.digroup_gid.toString(), row._data.digroup_gid + " - "+ desc));
    }
    this.textboxDiuserGid.items = items;
  }

  /** This is an event handler for the onClick event of mobileXrefButton. */
  mobileXrefButtonOnClick(event: ClickEvent) {
    const gtype =this.textboxDigroupType.text
    const login = this.textboxDiuserLogin.text;
    const layout = Layout.getLayout( "imaging/AccessAdmin/layout_dimuxref" ) as layout_dimuxref;
    new SlideoutDecorator({
        layout: layout,
        width: window.innerWidth * .50,
        height: window.innerHeight * .50,
        fillVerticalSpace: false,
        displayOverlay: true,
        overlayProps: { greyedBackground: true },
        title: "Mobile User Login: " + login,
        layoutLoadListeners: () => {
            layout.sourceDimuxref.search( { dimux_login: login } );
            layout.textboxDimuxLogin.text = login;
        },
      });
  }

/** This is an event handler for the onClick event of sendMobileLinkButton. */
  async sendMobileLinkButtonOnClick(event: ClickEvent) {
    this.sendMobileLinkButton.busy = true;
    const login = this.textboxDiuserLogin.text;
    const fname = this.textboxDiuserFullname.text;
    try {
        await Api.post("imaging-dplogix/dplinvoke", {action: "sendLink",
                        login: login }).then(response => {
        if( response && response.data[0] && response.data[0].reply != null )
        {
            //console.log( response );
            //const dplmsg = response.data[0].dplmsg;
            const reply = response.data[0].reply;
            if( reply != "0" )
                CommonDialogs.showMessage("Failed sending mobile link to: " + fname, "Document Power");
            else
                CommonDialogs.showMessage("Success sending mobile link to: " + fname, "Document Power");
        }
        else
            CommonDialogs.showMessage("Failed sending mobile link to: " + fname, "Document Power");
    });
    } finally {
        this.sendMobileLinkButton.busy = false;
    }
  }
}
